import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { RawTbody } from '../RawTable/RawTbody.js';

const TbodyWrapper = styled(RawTbody) `
  & tr:last-of-type {
    border-bottom: none;
  }
`;
const Tbody = ({ children, ...props }) => {
    return jsx(TbodyWrapper, { ...props, children: children });
};

export { Tbody };
